module.exports = __webpack_public_path__ + "img/banner_lista.55ce784a.webp";